import {
  ApiRoute,
  GetPlaceDetailsOptions,
  PlaceDetails,
  PlaceDetailsSchema,
  SearchPlaceOptions,
  SearchPlaceResponse,
  SearchPlaceResponseSchema,
  getApiRoute
} from "@humanex/interfaces";

import { ApiClientConfig, BaseApiClient } from "./base-client";

export class MapApiClient extends BaseApiClient {
  constructor(config: ApiClientConfig) {
    super({
      ...config,
      baseEndpoint: getApiRoute(ApiRoute.MAP)
    });
  }

  async searchPlace(options: SearchPlaceOptions): Promise<SearchPlaceResponse> {
    return await this.post("search", SearchPlaceResponseSchema, options, {
      requireAuth: false
    });
  }

  async getPlaceDetails(options: GetPlaceDetailsOptions): Promise<PlaceDetails> {
    const { placeId, languageCode, fieldMask } = options;
    const params: Record<string, string> = {};
    if (languageCode) {
      params.languageCode = languageCode;
    }
    if (fieldMask) {
      params.fieldMask = fieldMask.join(",");
    }

    return await this.get(`place/${placeId}`, PlaceDetailsSchema, {
      params,
      requireAuth: false
    });
  }
}
